import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=07079981&scoped=true&"
import script from "./mark.vue?vue&type=script&lang=js&"
export * from "./mark.vue?vue&type=script&lang=js&"
import style0 from "./mark.vue?vue&type=style&index=0&id=07079981&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07079981",
  null
  
)

export default component.exports